/**
 * @generated SignedSource<<9ab6be8b23527113989903c6c033776a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelay_smarts$data = {
  readonly recommendedUser: ReadonlyArray<{
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null | undefined;
      readonly extendedProfile?: {
        readonly jobTitle: string | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "UserProfilePreviewRelay_smarts";
};
export type UserProfilePreviewRelay_smarts$key = {
  readonly " $data"?: UserProfilePreviewRelay_smarts$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelay_smarts">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "recommendationsQuery"
    }
  ],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelay_smarts",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "recommendationsQuery",
          "variableName": "recommendationsQuery"
        }
      ],
      "concreteType": "SmartsRecommendedUser",
      "kind": "LinkedField",
      "name": "recommendedUser",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "concreteType": "AtlassianAccountUserExtendedProfile",
                  "kind": "LinkedField",
                  "name": "extendedProfile",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ]
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "SmartsQueryApi"
};

(node as any).hash = "a2d5baad05f5ef1535f48010805de39d";

export default node;
